// One colour per menu, so each listing is recognisable before its title is
// read. Values are "r g b" triplets for use as rgb(var(--mod) / alpha).
// Mid-tone hues that stay readable on both the light and dark themes.
export const MODULES = [
  { prefix: '/dashboard', rgb: '79 70 229' }, // indigo
  { prefix: '/tailoring-items', rgb: '124 58 237' }, // violet
  { prefix: '/customers', rgb: '2 132 199' }, // sky
  { prefix: '/invoices', rgb: '5 150 105' }, // emerald
  { prefix: '/view/invoices', rgb: '5 150 105' },
  { prefix: '/workers', rgb: '217 119 6' }, // amber
  { prefix: '/finance', rgb: '225 29 72' }, // rose
  { prefix: '/utility/worker-item-rates', rgb: '192 38 211' }, // fuchsia
  { prefix: '/measurements', rgb: '8 145 178' }, // cyan
  { prefix: '/reports', rgb: '234 88 12' }, // orange
  { prefix: '/portal', rgb: '5 150 105' },
];

export function moduleColor(pathname) {
  const hit = MODULES
    .filter((m) => pathname === m.prefix || pathname.startsWith(`${m.prefix}/`))
    .sort((a, b) => b.prefix.length - a.prefix.length)[0];
  return hit ? hit.rgb : null;
}
